import * as React from 'react';

const SvgCart = (props) => (
  <svg
    width={24}
    height={24}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M.818 1.272a.75.75 0 0 1 .91.546l.91 3.643h15.856c.931 0 1.7 0 2.303.073.628.077 1.202.245 1.66.677.196.184.363.397.497.63.314.546.343 1.144.271 1.772-.069.604-.248 1.351-.465 2.257l-.021.087c-.36 1.503-.643 2.685-.968 3.615-.333.953-.73 1.707-1.356 2.32-.296.292-.624.55-.976.771-.744.465-1.57.676-2.573.777-.98.1-2.196.1-3.741.1h-.594c-1.785 0-3.19 0-4.314-.131-1.152-.134-2.089-.412-2.902-1.024a5.81 5.81 0 0 1-.207-.163c-.785-.649-1.274-1.495-1.672-2.584-.39-1.062-.717-2.429-1.133-4.165l-.979-4.084L.273 2.182a.75.75 0 0 1 .545-.91Zm2.186 5.689.747 3.116c.43 1.793.738 3.075 1.093 4.046.349.952.717 1.527 1.22 1.942.05.042.1.082.153.121.521.392 1.165.616 2.173.733 1.027.12 2.345.12 4.19.12h.504c1.595 0 2.735 0 3.631-.091.88-.089 1.453-.26 1.927-.556.261-.163.503-.354.722-.57.4-.392.699-.909.99-1.744.297-.85.564-1.96.936-3.51.231-.965.387-1.623.445-2.126.056-.49 0-.71-.081-.854a1.249 1.249 0 0 0-.227-.287c-.12-.113-.32-.218-.811-.278-.503-.061-1.178-.062-2.17-.062H3.003ZM9.25 14a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z'
      fill='currentColor'
    />
    <path
      d='M10.474 20.947a1.053 1.053 0 1 1-2.105 0 1.053 1.053 0 0 1 2.105 0ZM16.79 20.947a1.053 1.053 0 1 1-2.106 0 1.053 1.053 0 0 1 2.106 0Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgCart;
